import { ConvertToJapaneseTime } from "@services/Utilities";

interface YobelyEditHistoryDropdownProps {
  contactHistoryData: any[];
  selectedOption?: string;
  handleDropdownChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const YobelyEditHistoryDropdown = ({
  contactHistoryData,
  selectedOption,
  handleDropdownChange,
}: YobelyEditHistoryDropdownProps) => {
  return (
    <label className="flex items-center">
      <select
        className="dropdown-bar"
        value={selectedOption}
        onChange={(e) => {
          handleDropdownChange(e);
        }}
      >
        <option value="newest">最新</option>
        {contactHistoryData?.map((item, index) => (
          <option key={index} value={item.created_at}>
            {ConvertToJapaneseTime(item.created_at)}
          </option>
        ))}
      </select>
    </label>
  );
};
